import { memo } from "react"

const IconArrowDownRed = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M12.0391 11.25C12.0391 11.4489 11.96 11.6397 11.8194 11.7803C11.6787 11.921 11.488 12 11.2891 12H5.27906C5.08015 12 4.88938 11.921 4.74873 11.7803C4.60808 11.6397 4.52906 11.4489 4.52906 11.25C4.52906 11.0511 4.60808 10.8603 4.74873 10.7197C4.88938 10.579 5.08015 10.5 5.27906 10.5H9.47906L4.21906 5.24C4.08238 5.09861 4.00669 4.9092 4.0083 4.71255C4.00992 4.5159 4.08871 4.32775 4.2277 4.18863C4.36669 4.04951 4.55476 3.97054 4.75141 3.96874C4.94806 3.96694 5.13755 4.04245 5.27906 4.179L10.5391 9.439V5.239C10.5391 5.04009 10.6181 4.84932 10.7587 4.70867C10.8994 4.56802 11.0902 4.489 11.2891 4.489C11.488 4.489 11.6787 4.56802 11.8194 4.70867C11.96 4.84932 12.0391 5.04009 12.0391 5.239V11.25Z"
        fill="#ED4040"
      />
    </svg>
  )
}

export default memo(IconArrowDownRed)
